export default {
  ADMIN: 'Admin',
  COMPANY_ADMIN: 'Company Admin',
  EMPLOYEE: 'Employee',
  MEDIA_VIEWER: 'Media Viewer',
  MEDIA_EDITOR: 'Media Editor'
};